import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import { ContactFooterFloat, ContactFooterShim } from '../../components/Footer';
import SteppedFlow from '../../components/SteppedFlow';
import { Text } from '../../components/Text';
import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchOnboarding } from '../../actions/onboardingActions';
import { newGuestUser } from '../../actions/userActions';
import { trackEvent } from '../../actions/trackEventActions';

import Intro from './Intro';
import Contact from './Contact';
import FamilySituation from './FamilySituation';
import Ages from './Ages';
import LifeChanges from './LifeChanges';
import Priorities from './Priorities';
import Incomes from './Incomes';
import SavingGoals from './SavingGoals';
import DebtAmounts from './DebtAmounts';
import CreditScore from './CreditScore';
import RetirementLength from './RetirementLength';
import RetirementExpenses from './RetirementExpenses';
import OtherRetirementIncomes from './OtherRetirementIncomes';
import ProtectingFamily from './ProtectingFamily';
import RiskComfort from './RiskComfort';
import EquityAllocation from './EquityAllocation';
import CurrentExpenses from './CurrentExpenses';
import Housing from './Housing';
import SavingsAccountTypes from './SavingsAccountTypes';
import SavingsAccountAmounts from './SavingsAccountAmounts';
import MonthlySavings from './MonthlySavings';

import ThankYou from './ThankYou';
import ScoreIntro from './ScoreIntro';
import ActionPlan from './ActionPlan';
import CallToAction from './CallToAction';
import { StepWrapper } from './StepWrapper';
import { ActionWrapper } from './ActionWrapper';
import ReviewWithHarbor from '../ReviewWithHarbor';

import { wlPath, wlVar } from '../../helpers/whitelabel';
import { isAutoCreatedEmail } from '../../helpers/stringHelper';

import {
  COLLECT_CONTACT_AFTER_ACTION_ITEMS,
  COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN,
  COLLECT_CONTACT_ON_LAST_ONBOARDING_SCREEN,
  COLLECT_CONTACT_BEFORE_SCORE_INTRO,
} from '../../helpers/constants';

export class Start extends Component {
  componentWillMount() {
    if (!this.props.dashboard.fetched) {
      this.props.dispatch(fetchDashboard());
      this.props.dispatch(fetchPeople());
    }
    if (!this.props.onboarding.fetched) this.props.dispatch(fetchOnboarding());
    this.redirectIfTooFar();
  }

  componentDidUpdate() {
    this.redirectIfTooFar();
  }

  buildSteps() {
    const { dashboard, dispatch, history, match, qna_hash, user } = this.props;
    return [
      ...(user.email_cohort === COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN
        ? [
            {
              path: '',
              component: Contact,
              headline: 'Tell us a little about yourself.',
              additionalDisclaimer: (<div dangerouslySetInnerHTML={{ __html: wlVar('disclosure') }} />),
              onBack: () => history.push(wlPath('')),
            },
          ]
        : []),
      {
        path: user.email_cohort !== COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN ? '' : '/family-situation',
        component: FamilySituation,
        headline: 'About You.',
        exampleKey: 'hasPartner',
        ...(user.email_cohort === COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN
          ? {}
          : { onBack: () => history.push(wlPath('')) }),
      },
      {
        path: '/age',
        component: Ages,
        headline: 'About You',
        exampleKey: 'primaryAge',
      },
      {
        path: '/life-changes',
        component: LifeChanges,
        headline: 'About You',
        exampleKey: 'lifeChangeMarriage',
      },
      {
        path: '/priorities',
        component: Priorities,
        headline: 'About You',
        exampleKey: 'priorities',
      },
      {
        path: '/income',
        component: Incomes,
        headline: 'Work and Income',
        exampleKey: 'primaryBase',
      },
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('save_up_for_goal')
        ? [
            {
              path: '/saving-goals',
              component: SavingGoals,
              headline: 'Saving Up for a Goal',
              exampleKey: 'savingGoals',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('become_debt_free')
        ? [
            {
              path: '/debt',
              component: DebtAmounts,
              headline: 'Becoming Debt-Free',
              exampleKey: 'creditCardsDebtAmount',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('become_debt_free')
        ? [
            {
              path: '/credit-score',
              component: CreditScore,
              headline: 'Becoming Debt-Free',
              exampleKey: 'creditScore',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('prepare_for_retirement')
        ? [
            {
              path: '/retirement-age',
              component: RetirementLength,
              headline: 'Preparing for Retirement',
              exampleKey: 'primaryRetirementAge',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('prepare_for_retirement')
        ? [
            {
              path: '/retirement-expenses',
              component: RetirementExpenses,
              headline: 'Preparing for Retirement',
              exampleKey: 'goalExpensesInRetirement',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('prepare_for_retirement')
        ? [
            {
              path: '/other-incomes',
              component: OtherRetirementIncomes,
              headline: 'Preparing for Retirement',
              exampleKey: 'pensionAccounts',
            },
          ]
        : []),
      ...(qna_hash.priorities &&
      (qna_hash.priorities.answer.includes('protect_your_family') || qna_hash.priorities.answer.includes('legacy_plan'))
        ? [
            {
              path: '/protecting-family',
              component: ProtectingFamily,
              headline: 'Protecting Your Family',
              exampleKey: 'primaryCoverage',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('managing_investments')
        ? [
            {
              path: '/risk',
              component: RiskComfort,
              headline: 'Managing Your Investments',
              additionalDisclaimer: (<div>
                <div>1: Risk is the possibility that your investments may lose value.</div>
                <div>Risk tolerance is an investor's general ability to withstand risk inherent in investing. An adviser uses their own experience and subjective evaluation of your answers to help determine your risk tolerance. Although the advisor may have directly or indirectly used the results of this questionnaire to determine a suggested asset allocation, there is no guarantee that the asset mix appropriately reflects your ability to withstand investment risk.</div>
              </div>),
              exampleKey: 'riskComfort',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('managing_investments')
        ? [
            {
              path: '/equity-allocation',
              component: EquityAllocation,
              headline: 'Managing Your Investments',
              exampleKey: 'equityAllocation',
            },
          ]
        : []),
      ...(qna_hash.priorities && qna_hash.priorities.answer.includes('get_finances_on_track')
        ? [
            {
              path: '/current-expenses',
              component: CurrentExpenses,
              headline: 'Getting Your Finances on Track',
              exampleKey: 'currentExpenses',
            },
          ]
        : []),
      {
        path: '/housing',
        component: Housing,
        headline: 'Your Housing situation',
        exampleKey: 'ownsPrimaryResidence',
      },
      {
        path: '/savings-accounts-types',
        component: SavingsAccountTypes,
        headline: 'Your Savings',
        exampleKey: 'accountTypes',
      },
      {
        path: '/savings-accounts-allocation',
        component: SavingsAccountAmounts,
        headline: 'Your Savings',
        exampleKey: 'accountTypeAmounts',
      },
      {
        path: '/monthly-savings',
        component: MonthlySavings,
        headline: 'Your Savings',
        exampleKey: 'monthlySavings',
      },
      ...(user.email_cohort === COLLECT_CONTACT_ON_LAST_ONBOARDING_SCREEN
        ? [
            {
              path: '/contact',
              component: Contact,
              headline: 'Your contact details to calculate your financial health score.',
            },
          ]
        : []),
      {
        path: '/complete',
        component: ThankYou,
        headline: 'Thank you!',
      },
      ...(user.email_cohort === COLLECT_CONTACT_BEFORE_SCORE_INTRO
        ? [
            {
              path: '/contact',
              component: Contact,
              headline: 'Your contact details to see your financial health score.',
            },
          ]
        : []),
      {
        path: '/score-intro',
        component: ScoreIntro,
        disableStepWrapper: true,
        onFinish: () => {
          dispatch(trackEvent('CONTINUED_FROM_SCORE_INTRO_PAGE'));
          history.push(wlPath('/action-plan'));
        },
      },
    ];
  }

  redirectIfTooFar() {
    if (!(this.props.user && this.props.onboarding.fetched && this.props.dashboard.fetched)) {
      return;
    }
    const { dashboard, history, match, qna_hash, user } = this.props;

    const steps = this.buildSteps();

    // if we want to prevent the user from going back to any quiz question after having submitted it
    const stepPaths = steps.map(step => `${match.url}${step.path}`);
    if (
      user.prevented_from_going_back_to_quiz &&
      !history.location.pathname.includes('/complete') &&
      !history.location.pathname.includes('/contact') &&
      !history.location.pathname.includes('/score-intro') &&
      stepPaths.includes(history.location.pathname)
    ) {
      history.push(`${match.url}/complete`);
    }

    // Steps are ordered.  If you find a step that:
    //   (a) is not the current step, and
    //   (b) does not have it's information submitted
    // Break from the loop and redirect to that step.
    for (const step of steps) {
      let fullpath = match.url + step.path;
      if (history.location.pathname === fullpath) {
        // If you reach the current step, you're in the right spot.
        break;
      } else if (step.component === Contact) {
        if (!this.props.user.first_name || !this.props.user.last_name || isAutoCreatedEmail(this.props.user.email)) {
          history.push(fullpath);
          break;
        }
      } else if (step.component === ThankYou) {
      } else if (step.component === ScoreIntro) {
      } else {
        // for screens that enter info into qna_hash
        if (!(step.exampleKey in qna_hash)) {
          history.push(fullpath);
          break;
        }
      }
    }
  }

  render() {
    const { dashboard, history, match, qna_hash, user } = this.props;
    const { fetched } = this.props.onboarding;

    if (!user || !dashboard.fetched || !fetched) {
      return <LoadingBar />;
    }

    const steps = this.buildSteps();

    return (
      <div className="onboarding">
        <Header showSignIn={false} />
        <SteppedFlow
          history={history}
          basePath={match.url}
          actionWrapper={<ActionWrapper />}
          stepWrapper={<StepWrapper />}
          steps={steps}
        />

        <Route path={match.url + '/review-plan'} component={ReviewWithHarbor} />

        <ContactFooterShim />
        <ContactFooterFloat />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard,
    onboarding: state.onboarding,
    qna_hash: state.onboarding.qna_hash,
  };
}

export default connect(mapStateToProps)(Start);
